export const refs = {
  contentMessage: document.querySelector('.js-content'),
  moviesList: document.querySelector('.js-movie-list'),
  loadMore: document.querySelector('.js-load-more'),
};
